import { render, staticRenderFns } from "./BaseFrontOfficeTitle.vue?vue&type=template&id=4a8ad397&scoped=true"
import script from "./BaseFrontOfficeTitle.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeTitle.vue?vue&type=style&index=0&id=4a8ad397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ad397",
  null
  
)

export default component.exports